import React, { useEffect, useState } from "react";
import { Card } from "@shopify/polaris";
import { Progress } from "reactstrap";
import ApexCharts from "react-apexcharts";
import { useSelector } from "react-redux";
import callApi from "../../utils/apiCaller";

const Chart = (props) => {
  const [options, setOptions] = useState({});
  const [series, setSeries] = useState([]);
  const [storeSelected, setStoreSelected] = useState(props.storeSelected);
  const typeChart = "line";

  useEffect(() => {
    getDataChart();
  }, [storeSelected]);

  useEffect(() => {
    setStoreSelected(props.storeSelected);
  }, [props.storeSelected]);

  const getDataChart = () => {
    const params = {
      action: "getDataChart",
      storeSelected: storeSelected,
      device: window.innerWidth < 800 ? "mobile" : "desktop",
    };
    callApi("get", params).then(async (res) => {
      const newOptions = {
        tooltip: {
          y: {
            formatter(val) {
              return val;
            },
          },
        },

        chart: {
          id: "shipments-chart",
          type: "line",
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: true,
              customIcons: [],
            },
          },
        },
        colors: [
          "#58aa64",
          "#00a0ac",
          "#df7e00",
          "#2b4975",
          "#969696",
          "#ffc107",
          "#6b2700",
          "#dc3545",
          "#cccccc",
          "#f8bb26",
        ],
        stroke: {
          width: 4,
        },
        xaxis: {
          categories: res.data.categories,
        },
      };
      setOptions(newOptions);
      setSeries(res.data.series);
    });
  };

  return (
    <div id="chart" className="mixed-chart w-100 mt-5">
      <div className={typeChart === "bar" ? "d-none" : "d-block"}>
        <ApexCharts
          options={options}
          series={series}
          type={typeChart}
          width="100%"
          height="300px"
        />
      </div>
    </div>
  );
};

export default Chart;
